import { render, staticRenderFns } from "./AddHospital.vue?vue&type=template&id=cdd7a39a&scoped=true&"
import script from "./AddHospital.vue?vue&type=script&lang=js&"
export * from "./AddHospital.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdd7a39a",
  null
  
)

export default component.exports